import { resolveCreatorPlatformProfile } from '../../../lib/platformProfile';
import { rowDisplayName } from '../../utils/rowDisplayName';
import type { CreatorsRow } from './types';

/** Compact "Name @handle" line used by the bulk action dialogs. */
export function BulkCreatorLine({ row, platform }: { row: CreatorsRow; platform: string }) {
  const { username } = resolveCreatorPlatformProfile(row, platform);
  return (
    <div className="min-w-0">
      <div className="truncate text-sm font-semibold text-foreground">{rowDisplayName(row)}</div>
      {username && <div className="truncate text-xs text-(--brand-400,#9647f8)">@{username}</div>}
    </div>
  );
}
